import { render, staticRenderFns } from "./columnDetail.vue?vue&type=template&id=2e19edf1&scoped=true&"
import script from "./columnDetail.vue?vue&type=script&lang=js&"
export * from "./columnDetail.vue?vue&type=script&lang=js&"
import style0 from "./columnDetail.vue?vue&type=style&index=0&id=2e19edf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19edf1",
  null
  
)

export default component.exports